// The cms uses a fixed set of colors
import type { MaybeRefOrGetter } from 'vue';

const colorMap = {
  color_general_background_neutral_lowest: '#f4f6f4',
  color_general_background_neutral_default: '#ffffff',
  color_general_background_neutral_high: '#e5e7e5',
  color_general_background_highlight_default: '#ffcc00',
  color_general_background_loyalty_friends_low: '#e7efe8',
  color_general_background_loyalty_friends_default: '#ffffff',
  color_general_background_loyalty_littlefriends_lower: '#ff9999',
  color_general_background_loyalty_littlefriends_low: '#fff2eb',
  color_general_text_brand_default: '#1c662a',
  color_general_text_neutral_default: '#383b38',
  color_general_text_neutral_low: '#565b56',
  color_general_text_neutral_lower: '#717671',
};

export const useCMSColorMap = (name: { name?: MaybeRefOrGetter<keyof typeof colorMap> } = {}) => {
  const color = computed(() => {
    return name in colorMap ? colorMap[name] : null;
  });

  return color;
};
